export const handleChangeInputSpecialRange = (e, id, action, values) => {

  const valuesOriginal = copyRecursive(values);
  const myValues = copyRecursive(values);

	const targetId = e.target.id;
	const value = e.target.value;

	if(!myValues[id]) myValues[id] = {};
  myValues[id][targetId] = value;
  
  let total = parseInt(myValues[id].aboveGroundWater || 0);
  total += parseInt(myValues[id].subterraneanWater || 0);
  total += parseInt(myValues[id].publicSupply || 0);
  total += parseInt(myValues[id].rainWater || 0);
  total += parseInt(myValues[id].reusedWater || 0);
  
  if(total <= 100) action(myValues, id, targetId);
  else e.target.value = valuesOriginal[id][targetId];
};

const copyRecursive = (original, i = 0) => {
  i += 1;
  if (i > 50) return "recursion_error";
  if (typeof original != "object") return original;

  let copy;
  if (original.constructor === Array) copy = [];
  else copy = {};

  for (let key in original) {
    const value = original[key];
    if (!value || typeof value != "object") copy[key] = value;
    else copy[key] = copyRecursive(value, i);
  }

  return copy;
};


// WEBPACK FOOTER //
// src/helpers/lib/handleChangeInputSpecialRange.js